import { IconRefresh } from '@tabler/icons-react';
import { Box, Button, Group, Text } from '@mantine/core';

interface IChatConversationListHeaderProps {
  size?: 'sm' | 'md';
  onRefresh?: () => void;
  isRefreshing?: boolean;
  refreshIsDisabled?: boolean;
}

export function ChatConversationListHeader({
  size = 'md',
  onRefresh,
  isRefreshing,
  refreshIsDisabled,
}: IChatConversationListHeaderProps) {
  const isNormalSize = size === 'md';

  return (
    <Group
      py={isNormalSize ? 'md' : '0.75rem'}
      px={isNormalSize ? '1rem' : '0.75rem'}
      justify="space-between"
      wrap="nowrap"
    >
      <Text fw="bold" fz={isNormalSize ? 'lg' : 'sm'}>
        Chat
      </Text>

      {onRefresh && (
        <Button
          variant="light"
          loading={isRefreshing}
          size={isNormalSize ? 'xs' : 'compact-xs'}
          onClick={onRefresh}
          disabled={refreshIsDisabled}
        >
          <Group gap={isNormalSize ? 'xs' : 0}>
            <Box hidden={isNormalSize}>
              <IconRefresh size="20" />
            </Box>
            <Text fz="sm" hidden={!isNormalSize}>
              Muat Ulang
            </Text>
          </Group>
        </Button>
      )}
    </Group>
  );
}
